<template>
  <md-list class="md-dense">
    <transition-group tag="li">
      <md-list-item class="maker" v-for="maker in makers" :key="maker.compnayCode + maker.makerCode">
        <md-checkbox
          v-if="selectable"
          :model="selected"
          @change="$emit('update:selected', $event)"
          :value="maker"
        />
        <span class="md-list-maker-text compnay-name">{{ maker.companyName }}</span>
        <span class="md-list-maker-text maker-code">{{ maker.makerCode }}</span>
        <span class="md-list-maker-text maker-name">{{ maker.makerName }}</span>
        <span v-if="deletable" class="icon-delete" @click="remove(maker)">
          <md-icon>remove_circle_outline</md-icon>
        </span>
      </md-list-item>
    </transition-group>
  </md-list>
</template>

<script>
/**
 * メーカーの一覧表示
 */
export default {
  props: {
    /**
     * 表示するメーカーリスト
     *
     * メーカーは以下の形式
     *
     * ```javascript
     * {
     *   companyCode: String,
     *   companyName: String,
     *   makerCode: String,
     *   makerName: String,
     * }
     * ```
     */
    makers: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択されているメーカー
     */
    selected: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択可能か
     */
    selectable: {
      type: Boolean,
      default: false,
    },
    /**
     * 削除可能か
     */
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 要素の削除
     */
    remove(maker) {
      this.$emit(
        'update:makers',
        this.makers.filter(i => i.makerCode !== maker.makerCode),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.maker {
  width: 100%;

  &:hover {
    background: rgba(0, 0, 0, 0.12);
  }
}

.md-list-maker-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// メーカーコード横幅を固定にし、企業名、メーカー名称を横幅いっぱいにする
.compnay-name {
  flex: 0.5;
}
.maker-code {
  flex: 0 0 70px;
}
.maker-name {
  flex: 1;
}

.icon-delete {
  cursor: pointer;
}

// メーカー一覧の追加/削除時のアニメーション
.maker {
  transition: all 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.v-leave-active {
  position: absolute;
}
</style>
